import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Dropdown from 'react-bootstrap/Dropdown';
import Icon from '@components/@core/Icon';

const Tabs = ({
    className,
    active,
    type = 'blue',
    data = [
        { type: 'tab', data: { id: 'foo', name: 'Foo' } },
        { type: 'dropdown', name: 'fas fa-gear', data: [{ id: 'poo', name: 'Poo' }] },
    ],
    getId = (e) => e['id'],
    getValue = (e) => e['name'],
    onTab = () => {},
    ...props
}) => (
    <div className={cx(className, 'ds-tabs', type)} {...props}>
        {data.map((item, index) => (
            <div
                className={cx('ds-tabs-tab', item.type === 'dropdown' && 'ml-auto', getId(item.data) === active && 'active')}
                key={`ds-tabs-${index}`}
                onClick={() => item.type === 'tab' && onTab(item.data)}
            >
                {item.type === 'tab' && <div className={cx('my-2 text-nowrap', index === 0 ? 'pr-3' : 'px-3', index === data.length - 1 && 'border-0')}>{getValue(item.data)}</div>}
                {item.type === 'dropdown' && item.data.length > 0 && (
                    <Dropdown className={cx(index === data.length - 1 && 'border-0')} alignRight>
                        <Dropdown.Toggle as="div" id="ds-tabs-dropdown">
                            <div className={cx('px-3 ssm-x-2', index === data.length - 1 && 'border-0')}>
                                <Icon name={item.name} color={type === 'blue' ? 'white' : '#376caf'} size={14} />
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {item.data.map((label, index) => (
                                <Dropdown.Item eventKey={index} key={index} onSelect={() => onTab(label)}>
                                    {getValue(label)}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
        ))}
    </div>
);

Tabs.propTypes = {
    className: PropTypes.string,
    active: PropTypes.string,
    type: PropTypes.oneOf(['blue', 'white']),
    data: PropTypes.array,
    getId: PropTypes.func,
    getValue: PropTypes.func,
    onTab: PropTypes.func,
};

export default Tabs;
